import { splatLoadingAtom } from '@/atoms';
import { LoadingBadge } from '@/components/ui/LoadingBadge';
import { useAtomValue } from 'jotai';
import { useTranslation } from 'react-i18next';

/**
 * Badge rows for splat-layer load progress while `SplatMeshNode` is
 * fetching/decoding. One row per layer; rows disappear as soon as
 * `SplatMesh.initialized` resolves. Failed loads stick around so the user
 * can see why nothing rendered.
 *
 * Renders rows only — `ViewerLoadingColumn` positions and stacks it with the
 * other loaders.
 */
export const SplatLoadingOverlay = () => {
  const { t } = useTranslation('project');
  const loading = useAtomValue(splatLoadingAtom);
  const entries = Object.values(loading);
  if (entries.length === 0) return null;

  const labels = {
    fetching: t('splatLoader.fetching'),
    decoding: t('splatLoader.decoding'),
    failed: t('splatLoader.failed'),
  };

  return (
    <>
      {entries.map((e) => (
        <LoadingBadge
          key={e.layerId}
          name={e.layerName}
          phase={e.phase}
          progress={e.progress}
          loadedBytes={e.loadedBytes}
          totalBytes={e.totalBytes}
          error={e.error}
          labels={labels}
        />
      ))}
    </>
  );
};
